/* Keep below-fold video playback; start loading only near the visible viewport. */
(() => {
  const initialize = () => {
    const videos = document.querySelectorAll('video[data-moreborn-deferred-video]');
    if (!('IntersectionObserver' in window)) {
      videos.forEach(video => { video.controls = true; });
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({target: video, isIntersecting}) => {
        if (isIntersecting) {
          video.play().catch(() => { video.controls = true; });
        } else {
          video.pause();
        }
      });
    }, {rootMargin: '100px 0px', threshold: 0.01});
    videos.forEach(video => observer.observe(video));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
/* Show the protection app in its original form, preserving app ownership. */
(() => {
  const initialize = () => {
    document.querySelectorAll('.mb4-extend-fold').forEach(fold => {
      const show = () => {
        document.querySelectorAll('.xcotton-productProtection-detail-warp').forEach(widget => {
          widget.style.setProperty('display', fold.open ? 'block' : 'none', 'important');
        });
      };
      const observer = new MutationObserver(show);
      fold.addEventListener('toggle', () => {
        observer.disconnect();
        show();
        if (fold.open) observer.observe(document.body, {childList: true, subtree: true});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
